function Tabs({el}) {
    var tabsObject = {
        el: el
    }

    function _toggleActive(element) {
        element.classList.toggle('is-active');
    }

    function _isCurrentTab(element) {
        return element.classList.contains('is-active');
    }

    function _getBlock(element) {
        return document.querySelector(element.getAttribute('href'));
    }

    function _handleClick(e) {
        e.preventDefault();
        if(!_isCurrentTab(e.target)){
            _toggleActive(this.currentTab);
            _toggleActive(_getBlock(this.currentTab))
            _toggleActive(e.target);
            _toggleActive(_getBlock(e.target));
            this.currentTab = e.target;
        }
    }

    tabsObject.init = function() {
        this.tabList = Array.from(this.el.querySelectorAll('.tabs__nav-list-item'));

        this.currentTab = this.el.querySelector('.is-active');

        this.tabList.forEach(item => {
            item.addEventListener('click', _handleClick.bind(this));
        });

    }

    return tabsObject;
}
